import { render, staticRenderFns } from "./HeatedDiscussion.vue?vue&type=template&id=b63821ce&scoped=true&lang=html"
import script from "./HeatedDiscussion.vue?vue&type=script&lang=js"
export * from "./HeatedDiscussion.vue?vue&type=script&lang=js"
import style0 from "./HeatedDiscussion.vue?vue&type=style&index=0&id=b63821ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b63821ce",
  null
  
)

export default component.exports